/* Autoplay af videoer i produkt-grid (layout-2/3). product-media.min.js autoplayer
   kun i slider-mode (playActiveMedia); grid-mode ('gallery') har ingen trigger.
   Dette script udfylder hullet via IntersectionObserver og springer slider-slides over. */
(function () {
  function playDeferred(dm) {
    if (dm.getAttribute('loaded')) return;
    if (typeof dm.loadContent === 'function') {
      dm.loadContent(false);
    }
    var vid = dm.querySelector('video');
    if (vid) {
      vid.muted = true;
      vid.setAttribute('muted', '');
      vid.playsInline = true;
      vid.setAttribute('playsinline', '');
      var p = vid.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }

  function collectTargets() {
    var targets = [];
    var galleries = document.querySelectorAll('media-gallery[data-enable-video-autoplay="true"]');
    Array.prototype.forEach.call(galleries, function (g) {
      var deferred = g.querySelectorAll('.deferred-media[data-auto-play="true"]');
      Array.prototype.forEach.call(deferred, function (dm) {
        // Slider-slides håndteres allerede af media-gallery (playActiveMedia).
        if (dm.closest('.swiper-wrapper') || dm.closest('.swiper-slide')) return;
        // Kun rigtige videoer — ikke 3D-modeller.
        if (dm.classList.contains('media-model') || dm.querySelector('product-model')) return;
        targets.push(dm);
      });
    });
    return targets;
  }

  function init() {
    var targets = collectTargets();
    if (!targets.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            playDeferred(e.target);
            obs.unobserve(e.target);
          }
        });
      }, { rootMargin: '150px 0px' });
      targets.forEach(function (dm) { io.observe(dm); });
    } else {
      targets.forEach(playDeferred);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
